import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Box } from "../../../model/box";

class BoxStatusEnable {
  box: Box = new Box();
  enable = false;
}

@Component({
  selector: 'aw-box-dialog',
  templateUrl: './box-dialog.component.html',
  styleUrls: ['./box-dialog.component.scss']
})
export class BoxDialogComponent implements OnInit {
  enableBox = false;
  box?: Box;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: BoxStatusEnable,
    public dialogRef: MatDialogRef<BoxDialogComponent>,
  ) {


  }

  ngOnInit(): void {
    this.enableBox = this.data.enable;
    this.box = this.data.box;
  }


}


